import 'reflect-metadata'
import 'express-async-errors'
import express, { Request } from "express";
import cookieParser from 'cookie-parser';
import { PlataformConfig } from './infrastructure/config/plataform.js';
import cors from 'cors';
import { customLog } from './infrastructure/config/logger.js';
import NantoiUserInitializer from './domain/meta-inf/NantoiUserInitializer.js';
import path, { dirname } from 'path';
import MiddllewareErrorHandling from '@nantoidigital/nantoi-lib-infrastructure-core/dist/types/infrastructure/exceptions/MiddllewareErrorHandling.js';
import { LogLevelEnum } from "@nantoidigital/nantoi-lib-infrastructure-core/dist/types/infrastructure/config/LogLevelEnum.js";
import swagger from './swagger.js';
import myDataSource from './domain/meta-inf/data-source.js';
import bodyParser from 'body-parser';
import  './infrastructure/config/modulesInitializer.js';
import { fileURLToPath } from 'url';
import sharedRoutes from "./application/routes-management/shared-routes/routes.js";


const __filename = fileURLToPath(import.meta.url);
const __dirname = dirname(__filename);

// Configuração do Swagger
customLog(LogLevelEnum.INFO, "[Server] Initializing server...")

myDataSource.initialize().then(() => {
    // create and setup express app
    const app = express()

    var allowList = PlataformConfig.url?.allowList?.split(",") || [];

    const corsOptionsDelegate = (req, callback) => {

        let corsOptions;
        if (allowList.indexOf(req.header('Origin')) !== -1) {
            corsOptions = {
                origin: true,
                credentials: true
             }
        } else {
            corsOptions = { origin: false }
        }
        callback(null, corsOptions);
    }

    customLog(LogLevelEnum.INFO, "[Server] Defining cors option...")
    app.use(cors(corsOptionsDelegate));
    app.options('*', cors(corsOptionsDelegate));

    customLog(LogLevelEnum.INFO, "[Server] Defining body parser...")
    app.use(bodyParser.json({
        // Because Stripe needs the raw body, we compute it but only when hitting the Stripe callback URL.
        verify: function(req:Request,res,buf) {
            var url = req.url.trim();
            const expectedValue=(PlataformConfig.url.baseUrl+'/payments/webhook').trim()
            if (url===expectedValue) {
                req.rawBody = buf.toString()
            }
        }}));

        customLog(LogLevelEnum.INFO, "[Server] Defining cookie secret...")

    app.use(cookieParser(process.env.COOKIE_SECRET));

    app.use(express.urlencoded({ extended: true }));  // Para lidar com dados de formulários URL encoded
    customLog(LogLevelEnum.INFO, "[Server] Defining express...")
    app.use(express.json())

    app.use('/assets', express.static(path.join(__dirname, 'src/assets')));

    customLog(LogLevelEnum.INFO, "[Server] Defining shared routes...")
    app.use(sharedRoutes)

    customLog(LogLevelEnum.INFO, "[Server] Defining middleware error handling...")
    app.use(MiddllewareErrorHandling)


    customLog(LogLevelEnum.INFO, "[Server] loading environment variable for content...")

    customLog(LogLevelEnum.INFO, "[Server] Loading folder uploads %s", PlataformConfig.server.uploadFolder)
    app.use('/' + PlataformConfig.server.uploadFolder, express.static(PlataformConfig.server.uploadFolder));

    customLog(LogLevelEnum.INFO, "[Server] Loading folder logotipo %s", PlataformConfig.server.uploadLogoFolder)
    app.use('/'+PlataformConfig.server.uploadLogoFolder, express.static(path.join(__dirname,PlataformConfig.server.uploadLogoFolder))); 

    customLog(LogLevelEnum.INFO, "[Server] Defining swagger...")
    swagger(app);

    customLog(LogLevelEnum.INFO, "[Server] Start running server...")
    app.listen(PlataformConfig.server.port);


}).catch((error: any) => {
    customLog(LogLevelEnum.ERROR, "[Server] Error while starting server on port" + " " + PlataformConfig.server.port, error)
 throw error
}).finally(async () => {

    const nantoiUserInitializer = new NantoiUserInitializer();
    try {
        customLog(LogLevelEnum.INFO, "[Server] Initializing nantoi user...")
        await nantoiUserInitializer.initNantoiUser();
    }
    catch (error) {
        customLog(LogLevelEnum.ERROR, "[Server] Error while initializing nantoi user", error)
        throw error
    }
 
  customLog(LogLevelEnum.INFO, "[Server] Server started on port", PlataformConfig.server.port)
})